// ── FormClaudePanel (Evo Brain) ──────────────────────────────────────────────
// No renderiza UI propia — el shell vive en AssistantDock (ver
// contexts/AssistantContext.tsx). Mismo patrón que ReportClaudePanel/
// ProjectClaudePanel: solo registra la entidad activa para que el dock deje
// de mostrar el contexto del último módulo visitado (bug real — Formularios
// nunca se registraba, así que heredaba lo que hubiera quedado activo, ej.
// Reportes).
import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';
import type { FormDef } from '@evo-hub/shared';

interface Props {
  form: FormDef;
  section?: string;
}

export function FormClaudePanel({ form, section }: Props) {
  const { t } = useTranslation();

  useAssistantModule('form', form.id, section);

  useRegisterAssistantActive('form', form.id, {
    title: t('forms.assistant.title'),
    placeholder: t('forms.assistant.placeholder'),
    emptyHint: t('forms.assistant.empty'),
    entityLink: { label: form.name, href: `/formularios/${form.id}` },
  });

  return null;
}
